module.exports = __webpack_public_path__ + "static/img/logo-new.82d482fc.png";